/**import React,{useState} from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import AsavacalXT from '../Assets/asavacal-xt.jpeg';
import Asvizole from "../Assets/asvizole.jpeg";
import AsvizoleDSR from '../Assets/asvizole-dsr.jpeg';
import Asvacal from "../Assets/asvacal.jpeg";
import ProductOverlay from './ourProducts';
import Footer from './footer';

function Products() {
    const [details1, setDetails1] = useState(false);

    const handleShowDetails1 = ()=>{
        setDetails1(!details1);
    }
    const [details2, setDetails2] = useState(false);

    const handleShowDetails2 = ()=>{
        setDetails2(!details2);
    }
    const [details3, setDetails3] = useState(false);

    const handleShowDetails3 = ()=>{
        setDetails3(!details3);
    }
    const [details4,setDetails4] = useState(false);

    const handleShowDetails4=()=>{
        setDetails4(!details4);
    }
    return (
        <Container fluid style={{padding: "0px 0px" , marginBottom: "0px"}}>
        <ProductOverlay heading = "Our Products"/>
        <Row className="justify-content-center" style={{marginTop: "20px"}}>
            <Col xs={12} sm={6} md={4} lg={3} className="mb-4">
            <Card  style={{ width: '100%', height: 'auto', minHeight: '400px' }}>
                <Card.Img variant="top" src={AsavacalXT} />
                <Card.Body>
                <Card.Title>Asavacal XT</Card.Title>
                <Card.Text>
                    {details1 &&(
                    <span style={{fontFamily:"MozAnimation"}}>
                        Asvacal XT is a powerful dietary supplement designed to support 
                        bone health and overall well-being. With its unique combination 
                        of Calcium Carbonate, Vitamin B3, Mecobalamin, L-Methyl Folate 
                        Calcium, and Pyridoxal 5-Phosphate, it offers essential nutrients 
                        that work together to promote optimal health. Always consult your 
                        healthcare provider to determine if Asvacal XT is suitable for 
                        your individual needs.
                    </span>
                    )}
                </Card.Text>
                <Button variant="primary" onClick={handleShowDetails1}>See Details</Button>
                </Card.Body>
            </Card>
            </Col>
            

            <Col xs={12} sm={6} md={4} lg={3} className="mb-4">
            <Card style={{ width: '100%', height: 'auto', minHeight: '400px' }}>
                <Card.Img variant="top" src={Asvizole} />
                <Card.Body>
                <Card.Title>Asvizole DSR</Card.Title>
                <Card.Text>
                    {details2 &&(
                    <span style={{fontFamily:"MozAnimation"}}>
                        Asvizole DSR is a reliable choice for managing gastrointestinal 
                        discomfort associated with acid-related disorders. With its unique 
                        combination of enteric-coated Rabeprazole Sodium and sustained-release 
                        Domperidone, it offers effective relief from symptoms while promoting
                        overall digestive health. Always consult your healthcare provider for 
                        personalized medical advice and to determine if Asvizole DSR is suitable 
                        for your condition.
                    </span>
                    )}
                </Card.Text>
                <Button variant="primary" onClick={handleShowDetails2}>See Details</Button>
                </Card.Body>
            </Card>
            </Col>


            <Col xs={12} sm={6} md={4} lg={3} className="mb-4">
            <Card style={{ width: '100%', height: 'auto', minHeight: '400px' }}>
                <Card.Img variant="top" src={AsvizoleDSR} style={{height : "400px"}} />
                <Card.Body>
                <Card.Title>Asvizole DSR</Card.Title>
                <Card.Text>
                    {details3 &&(
                    <span style={{fontFamily:"MozAnimation"}}>
                        Asvizole DSR is a reliable choice for managing gastrointestinal 
                        discomfort associated with acid-related disorders. With its unique 
                        combination of enteric-coated Rabeprazole Sodium and sustained-release 
                        Domperidone, it offers effective relief from symptoms while promoting
                        overall digestive health. Always consult your healthcare provider for 
                        personalized medical advice and to determine if Asvizole DSR is suitable 
                        for your condition.
                    </span>
                    )}
                </Card.Text>
                <Button variant="primary" onClick={handleShowDetails3}>See Details</Button>
                </Card.Body>
            </Card>
            </Col>

            <Col xs={12} sm={6} md={4} lg={3} className="mb-4">
            <Card  style={{ width: '100%', height: 'auto', minHeight: '400px' }}>
                <Card.Img variant="top" src={Asvacal} />
                <Card.Body>
                <Card.Title>Asavacal </Card.Title>
                <Card.Text>
                    {details4 &&(
                    <span style={{fontFamily:"MozAnimation"}}>
                        Asvacal is an excellent choice for supporting bone health 
                        and overall well-being. Formulated with a potent combination 
                        of Calcium Carbonate and Vitamin D3, this supplement effectively 
                        addresses calcium deficiencies while enhancing calcium absorption 
                        in the body.Always consult your healthcare provider for personalized 
                        medical advice.
                    </span>
                    )}
                </Card.Text>
                <Button variant="primary" onClick={handleShowDetails4}>See Details</Button>
                </Card.Body>
            </Card>
            </Col> 
            
        </Row>
        <Row style={{marginTop: "80px", 
            backgroundColor: "rgb(240,240,240)",
            borderRadius: "10px"
            }}>
            <Footer/>
        </Row>
        </Container>
    );
    }

export default Products;**/


import React, { useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Row } from 'react-bootstrap';
import AsavacalXT from '../Assets/asavacal-xt.jpeg';
import Asvizole from "../Assets/asvizole.jpeg";
import AsvizoleDSR from '../Assets/asvizole-dsr.jpeg';
import Asvacal from "../Assets/asvacal.jpeg";
import ProductOverlay from './ourProducts';
import Footer from './footer';
import "./front.css";
import Asvicoxib from '../Assets/asavicoxib-90.jpg';
import Cartivorix from '../Assets/cartivorix.jpg';
import VitnomacCD3 from '../Assets/vitnomac-cd3.jpg';
import JointFlam from '../Assets/jointflam.jpg';

const products = [
    {
        id: 1,
        image: AsavacalXT,
        category: "Bone Health",
        title: "Asavacal XT",
        subtitle: "Calcium + Vitamins Complex",
        description: `Asvacal XT is a powerful dietary supplement designed to support 
            bone health and overall well-being. With its unique combination 
            of Calcium Carbonate, Vitamin B3, Mecobalamin, L-Methyl Folate 
            Calcium, and Pyridoxal 5-Phosphate, it offers essential nutrients 
            that work together to promote optimal health. Always consult your 
            healthcare provider to determine if Asvacal XT is suitable for 
            your individual needs.`
    },
    {
        id: 2,
        image: Asvizole,
        category: "Gastro",
        title: "Asvizole",
        subtitle: "Gastrointestinal Relief",
        description: `Asvizole DSR is a reliable choice for managing gastrointestinal 
            discomfort associated with acid-related disorders. With its unique 
            combination of enteric-coated Rabeprazole Sodium and sustained-release 
            Domperidone, it offers effective relief from symptoms while promoting
            overall digestive health. Always consult your healthcare provider for 
            personalized medical advice.`
    },
    {
        id: 3,
        image: AsvizoleDSR,
        category: "Gastro",
        title: "Asvizole DSR",
        subtitle: "Rabeprazole + Domperidone",
        description: `Asvizole DSR is a reliable choice for managing gastrointestinal 
            discomfort associated with acid-related disorders. With its unique 
            combination of enteric-coated Rabeprazole Sodium and sustained-release 
            Domperidone, it offers effective relief from symptoms while promoting
            overall digestive health. Always consult your healthcare provider for 
            personalized medical advice.`
    },
    {
        id: 4,
        image: Asvacal,
        category: "Bone Health",
        title: "Asavacal",
        subtitle: "Calcium + Vitamin D3",
        description: `Asvacal is an excellent choice for supporting bone health 
            and overall well-being. Formulated with a potent combination 
            of Calcium Carbonate and Vitamin D3, this supplement effectively 
            addresses calcium deficiencies while enhancing calcium absorption 
            in the body. Always consult your healthcare provider for personalized 
            medical advice.`
    },
    {
        id: 5,
        image: Asvicoxib,
        category: "Pain Relief",
        title: "Asvicoxib-90",
        subtitle: "Asvicoxib Tablets IP 90mg",
        description: `Asvicoxib-90 is a trusted choice for effective pain and inflammation 
                management. Formulated with 90mg of its active ingredient, this selective 
                COX-2 inhibitor provides targeted relief from conditions such as osteoarthritis, 
                rheumatoid arthritis, ankylosing spondylitis, and acute gouty arthritis. 
                It works by blocking the enzymes responsible for pain and swelling, offering 
                fast and reliable relief. Always consult your healthcare provider for 
                personalized medical advice.`
    },
    {
        id: 6,
        image: Cartivorix,
        category: "Joint Health",
        title: "Cartivorix",
        subtitle: "Boswellic Acid, Glucosamine Sulphate, Chondroitin Sulphate & More",
        description: `Cartivorix is a comprehensive joint health supplement designed 
                to support cartilage repair, joint lubrication, and overall musculoskeletal 
                function. Powered by a synergistic blend of Boswellic Acid, Glucosamine 
                Sulphate, Chondroitin Sulphate, Curcumin, Hyaluronic Acid, Vitamin D3, 
                Vitamin K2-7, and Zinc, it helps reduce joint stiffness and supports 
                long-term bone and cartilage health. Always consult your healthcare 
                provider for personalized medical advice.`
    },
    {
        id: 7,
        image: VitnomacCD3,
        category: "Nerve Care",
        title: "Vitnomac CD3",
        subtitle: "Methylcobalamin, Alpha Lipoic Acid, Benfotiamine & More",
        description: `Vitnomac CD3 is a comprehensive neuro-nutrition supplement formulated 
                to support nerve health, healthy metabolism and bone strength. Its blend of 
                Methylcobalamin, Alpha Lipoic Acid, Benfotiamine, Folic Acid, Chromium 
                Polynicotinate, Inositol, Pyridoxine Hydrochloride, Vitamin D3 and Calcium 
                Carbonate helps address nutritional deficiencies associated with diabetic 
                neuropathy, nerve weakness and tingling or numbness in the hands and feet. 
                Available in 1x10 and 10x1x10 tablet packs. Always consult your healthcare 
                provider for personalized medical advice.`
    },
    {
        id: 8,
        image: JointFlam,
        category: "Pain Relief",
        title: "JointFlam",
        subtitle: "Pain Relief Oil Roll-On 50ml",
        description: `JointFlam Pain Relief Oil is a convenient roll-on formulation that 
                delivers fast, targeted relief from joint and muscle pain, swelling, sprains 
                and stiffness. The mess-free applicator makes it easy to apply directly to 
                knees, shoulders, back and other affected areas, making it suitable for 
                everyday aches, sports strains and age-related joint discomfort. For external 
                use only. Available in a 50ml roll-on pack. Always consult your healthcare 
                provider for personalized medical advice.`
    }
];

const ProductCard = ({ product }) => {
    const [open, setOpen] = useState(false);
    const cardRef = useRef(null);

    const handleMouseMove = (e) => {
        const card = cardRef.current;
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const cx = rect.width / 2;
        const cy = rect.height / 2;
        const rotateX = ((y - cy) / cy) * 5;
        const rotateY = ((x - cx) / cx) * -5;
        card.style.transform = `perspective(800px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-10px)`;
    };

    const handleMouseLeave = () => {
        const card = cardRef.current;
        card.style.transform = 'perspective(800px) rotateX(0deg) rotateY(0deg) translateY(0)';
    };

    return (
        <div
            className="product-card"
            ref={cardRef}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
        >
            <div className="card-shimmer" />

            <div className="card-img-wrap">
                <img
                    src={product.image}
                    alt={`${product.title} - ${product.subtitle} | Asava Pharmaceutical Lucknow UP`}
                    loading="lazy"
                />
                <div className="card-img-overlay" />
                <span className="card-category">{product.category}</span>
            </div>

            <div className="card-body-custom">
                <div className="card-title-custom">{product.title}</div>
                <div className="card-subtitle-custom">{product.subtitle}</div>

                <div className={`card-text-custom ${open ? 'open' : ''}`}>
                    {product.description}
                </div>
                {/* visually hidden but indexable by Google */}
                <p style={{
                    position: 'absolute', width: '1px', height: '1px',
                    padding: 0, margin: '-1px', overflow: 'hidden',
                    clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0
                }}>
                    {product.description}
                </p>

                <button
                    className={`card-btn-custom ${open ? 'active' : ''}`}
                    onClick={() => setOpen(!open)}
                >
                    {open ? 'Hide Details' : 'See Details'}
                </button>
            </div>
        </div>
    );
};

const Products = () => {
    return (
        <Container fluid style={{ padding: 0, marginBottom: 0 }}>
            <Helmet>
                <title>Our Products | Asava Pharmaceutical Pvt Ltd — Lucknow, UP</title>
                <meta name="description" content="Buy quality medicines from Asava Pharmaceuticals — bone health, gastro relief, pain management & joint care tablets. Available for patients and pharma distributors across Uttar Pradesh and India." />
                <link rel="canonical" href="https://www.asavapharma.in/products" />
            </Helmet>
            <ProductOverlay heading="Our Products" />

            <div className="products-grid">
                {products.map(product => (
                    <ProductCard key={product.id} product={product} />
                ))}
            </div>

            <Row style={{ marginTop: '80px' }}>
                <Footer />
            </Row>
        </Container>
    );
};

export default Products;